<template>
  <form id="form-title">
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        id="form-title"
        placeholder="Task title"
        v-model="title"
      />
    </div>
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        id="form-category"
        placeholder="Backlog, Todo, Doing or Done"
        v-model="category"
      />
    </div>
    <div class="mb-3 text-center">
      <button type="submit" class="btn btn-primary text-center" @click.prevent="addTask">Submit</button>
    </div>
  </form>
</template>

<script>
export default {
    name: "FormAdd",
    data() {
      return {
        title: '',
        category: ''
      }
    },
    methods: {
      addTask() {
        const {title, category} = this
        console.log({title, category}, "<< form add");
        this.$emit('addData', {title, category})
      }
    }
};
</script>

<style>
</style>